import { Controller } from "@hotwired/stimulus"

import Sortable from "sortablejs"
import { put } from "@rails/request.js"

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = {
    group: String
  }

  connect() {
    Sortable.create(this.element, {
      onEnd: this.onEnd.bind(this),
      group: this.groupValue,
      ghostClass: 'moving-card'
    })
  }

  onEnd(event) {
    let sortableUrl = event.item.dataset.sortableUrl
    let listId = event.to.dataset.sortableListId
    put(sortableUrl, {
      body: JSON.stringify({
        row_order_position: event.newIndex,
        list_id: listId,
      }),
      responseKind: "TURBO_STREAM"
    })
  }
}
